import fetchAllProducts from "@api/operations/fetch-all-products";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import Head from "next/head";
import Router from "next/router";
import React from "react";

import Container from "@components/Container";
import MainLayout from "@components/MainLayout";
import PaginationWithResultsCount from "@components/PaginationWithResultsCount";
import ProductCardGrid from "@components/ProductCardGrid";
import Spacer from "@components/Spacer";
import TitleBold from "@components/TitleBold";

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const {
    cookies: { token },
  } = req;
  const { page } = query;
  const { products, pageInfo } = await fetchAllProducts(token, {
    criteria: [{ field: "itemtype", value: "LMSTDS" }],
    pageRequest: {
      page: page ? parseInt(page as string) - 1 : 0,
      size: 6,
      direction: "ASC",
      sort: "id",
    },
  });

  return {
    props: { products, pageInfo },
  };
};

export type IndexPropsType = InferGetServerSidePropsType<typeof getServerSideProps>;

export default function CourseCatalog({ products, pageInfo }: IndexPropsType) {
  return (
    <>
      <Head>
        <title>Course Catalog | Mount Olive Family Medicine Center Online Training</title>
      </Head>
      <Spacer size="md" />
      <Container>
        <TitleBold text="Course Catalog" />
        <Spacer size="sm" />
        <ProductCardGrid products={products} />
        {pageInfo && pageInfo.totalPages > 1 && (
          <>
            <Spacer size="md" />
            <PaginationWithResultsCount
              perPage={pageInfo.size}
              itemCount={parseInt(pageInfo.totalElements)}
              page={pageInfo.page}
              onPageChange={(value) => {
                Router.push(`${Router.pathname}?page=${value + 1}`);
              }}
            />
          </>
        )}
        <style jsx>{`
          h1 {
            font-size: 30px;
            font-weight: 500;
          }
        `}</style>
      </Container>
    </>
  );
}

CourseCatalog.Layout = MainLayout;
